import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import s from './Point.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './swiper.css';
import { AudioPlayerComponent } from "../../Components/AudioPlayer/AudioPlayer";
import { ReactComponent as Arrow } from '../../assets/arrowright.svg'
import { MapBox } from "../../Components/MapBox/MapBox";
import { NavigationBar } from "../../Components/NavigationBar/NavigationBar";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useMemo } from "react";



export const Point = () => {
    const { points } = useSelector(state => state.points);
    const { sort_order } = useParams();  // теперь из URL берётся sort_order
    const { t } = useTranslation();
    const [text, setText] = useState([]);

    const pointData = useMemo(() => {
        return points.find(p => p.sort_order === Number(sort_order)) || {};
    }, [points, sort_order]);

    useEffect(() => {
        if (pointData.text_speaker) {
            const paragraphArray = pointData.text_speaker.split('\r\n');
            const paragraphElements = paragraphArray.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
            ));
            setText(paragraphElements);
        }
    }, [pointData]);

    const pointInMap = pointData.lat && pointData.lng ? [pointData] : [];

    window.scrollTo({ top: 0, behavior: 'smooth' });

    const sortedPoints = [...points].sort((a, b) => a.sort_order - b.sort_order);
    const currentIndex = sortedPoints.findIndex(p => p.sort_order === Number(sort_order));
    const prevPoint = sortedPoints[currentIndex - 1];
    const nextPoint = sortedPoints[currentIndex + 1];

    return (
        <div className={s.object}>
            <NavigationBar
                mainPage={t('mainNavigationBar')}
                webVersion={t('webNavigationBar')}
                pageName={pointData.place_name_locale}
            />

            <div className={s.title_body}>
                <NavLink to={'/points'}>
                    <Arrow className={s.arrow} />
                </NavLink>
                <h1 className={s.title}>{pointData.place_name_locale}</h1>
            </div>

            <div className={s.swiper}>
                {pointData.place_images &&
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        loop
                        pagination={{ clickable: true }}
                    >
                        {Object.values(pointData.place_images).map((imageUrl, index) => (
                            <SwiperSlide key={index}>
                                <img src={imageUrl} alt='' />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                }
            </div>

            <AudioPlayerComponent duration={pointData.duration} src={pointData.place_sound} />

            <div className={s.text}>
                {text}
            </div>

            <div className={s.nav_links}>
                <NavLink to={`/points`}>{t('toTheList')}</NavLink>
                {prevPoint && <NavLink to={`/points/${prevPoint.sort_order}`}>{t('previousObject')}</NavLink>}
                {nextPoint && <NavLink to={`/points/${nextPoint.sort_order}`}>{t('nextObject')}</NavLink>}
            </div>

            <div className={s.map_title}>
                {t('objectOnMap')}
            </div>
            <MapBox points={pointInMap} center={[pointData.lng, pointData.lat]} />
        </div>
    );
};

